import React from 'react';
import { TypeformContextProvider } from './TypeformContextProvider';

export type TypeformProviderProps = React.PropsWithChildren<{}>;

export const TypeformProvider: React.FC<TypeformProviderProps> = ({ children }) => {
  const [showTypeformDialog, setShowTypeformDialog] = React.useState(false);

  const handleShowTypeformDialog = React.useCallback(() => {
    setShowTypeformDialog(true);
  }, [setShowTypeformDialog]);

  const handleHideTypeformDialog = React.useCallback(() => {
    setShowTypeformDialog(false);
  }, [setShowTypeformDialog]);

  return (
    <>
      <TypeformContextProvider
        value={{
          setShowTypeform: handleShowTypeformDialog,
          showTypeform: showTypeformDialog,
          setHideTypeform: handleHideTypeformDialog,
        }}
      >
        {children}
      </TypeformContextProvider>
    </>
  );
};
